const AddPhoto = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="128"
      height="94"
      viewBox="0 0 128 94"
      fill="none"
    >
      <g filter="url(#filter0_dd_574_3331)">
        <rect
          x="2"
          width="124"
          height="88"
          rx="8"
          fill="#F5F5F5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3447 58.3763L14.4771 58.6106L14.8453 57.7431L14.3861 56.9469L15.271 57.0302L15.8547 56.3037L16.0335 57.2228L16.8534 57.57L16.079 58.0547L16.002 58.9958L15.3447 58.3763Z"
          stroke="#F3A802"
          strokeWidth="0.379272"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M102.748 74.0006L101.844 74.2397L102.225 73.3462L101.744 72.5237L102.667 72.6123L103.273 71.8649L103.462 72.8132L104.318 73.1738L103.512 73.6712L103.435 74.6414L102.748 74.0006Z"
          stroke="#F3A802"
          strokeWidth="0.379272"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.775 50.4573L108.742 50.7306L109.178 49.7094L108.628 48.7695L109.682 48.8708L110.375 48.0166L110.591 49.1004L111.57 49.5124L110.649 50.0809L110.56 51.1897L109.775 50.4573Z"
          stroke="#17BFDD"
          strokeWidth="0.379272"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.2465 38.7765L34.379 39.0109L34.7472 38.1434L34.288 37.3471L35.1729 37.4305L35.7566 36.704L35.9353 37.6231L36.7553 37.9703L35.9808 38.455L35.9039 39.3961L35.2465 38.7765Z"
          stroke="#17BFDD"
          strokeWidth="0.379272"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5496 31.3799C17.5706 31.2773 17.5045 31.1771 17.4019 31.156C17.2993 31.1349 17.1991 31.201 17.178 31.3036L16.9869 32.2346C16.9658 32.3372 17.0319 32.4374 17.1345 32.4585C17.2371 32.4796 17.3373 32.4135 17.3584 32.3109L17.5496 31.3799Z"
          fill="#09798D"
        />
        <path
          d="M15.2893 32.4567C15.1867 32.4357 15.0865 32.5018 15.0654 32.6044C15.0444 32.707 15.1105 32.8072 15.2131 32.8283L16.144 33.0194C16.2466 33.0405 16.3468 32.9744 16.3679 32.8718C16.389 32.7692 16.3229 32.669 16.2203 32.6479L15.2893 32.4567Z"
          fill="#09798D"
        />
        <path
          d="M17.5479 33.2249C17.569 33.1223 17.6693 33.0563 17.7719 33.0774L18.7028 33.2688C18.8054 33.2899 18.8715 33.3902 18.8504 33.4928C18.8293 33.5954 18.729 33.6614 18.6264 33.6403L17.6955 33.4489C17.5929 33.4278 17.5268 33.3275 17.5479 33.2249Z"
          fill="#09798D"
        />
        <path
          d="M16.9289 33.8624C16.95 33.7598 16.8839 33.6596 16.7813 33.6385C16.6787 33.6174 16.5785 33.6835 16.5574 33.7861L16.3663 34.7171C16.3452 34.8197 16.4113 34.9199 16.5139 34.941C16.6165 34.962 16.7167 34.896 16.7378 34.7934L16.9289 33.8624Z"
          fill="#09798D"
        />
        <path
          d="M26.4622 66.8418C26.4832 66.7392 26.4171 66.639 26.3145 66.6179C26.2119 66.5969 26.1117 66.663 26.0906 66.7655L25.8995 67.6965C25.8784 67.7991 25.9445 67.8993 26.0471 67.9204C26.1497 67.9415 26.2499 67.8754 26.271 67.7728L26.4622 66.8418Z"
          fill="#17BFDD"
        />
        <path
          d="M24.2019 67.9187C24.0993 67.8976 23.9991 67.9637 23.978 68.0663C23.957 68.1689 24.0231 68.2691 24.1257 68.2902L25.0566 68.4813C25.1592 68.5024 25.2594 68.4363 25.2805 68.3337C25.3016 68.2311 25.2355 68.1309 25.1329 68.1098L24.2019 67.9187Z"
          fill="#17BFDD"
        />
        <path
          d="M26.4605 68.6868C26.4816 68.5842 26.5819 68.5182 26.6845 68.5393L27.6154 68.7307C27.718 68.7518 27.7841 68.8521 27.763 68.9547C27.7419 69.0573 27.6416 69.1233 27.539 69.1022L26.6081 68.9108C26.5055 68.8897 26.4394 68.7894 26.4605 68.6868Z"
          fill="#17BFDD"
        />
        <path
          d="M25.8415 69.3243C25.8626 69.2217 25.7965 69.1215 25.6939 69.1004C25.5913 69.0794 25.4911 69.1454 25.47 69.248L25.2789 70.179C25.2578 70.2816 25.3239 70.3818 25.4265 70.4029C25.5291 70.424 25.6293 70.3579 25.6504 70.2553L25.8415 69.3243Z"
          fill="#17BFDD"
        />
        <path
          d="M89.0427 21.3292C89.0638 21.2266 88.9977 21.1264 88.8951 21.1053C88.7925 21.0842 88.6923 21.1503 88.6712 21.2529L88.48 22.1839C88.459 22.2865 88.5251 22.3867 88.6277 22.4078C88.7303 22.4288 88.8305 22.3627 88.8516 22.2602L89.0427 21.3292Z"
          fill="#F3A802"
        />
        <path
          d="M86.7825 22.406C86.6799 22.385 86.5797 22.4511 86.5586 22.5536C86.5375 22.6562 86.6036 22.7565 86.7062 22.7775L87.6372 22.9687C87.7397 22.9898 87.84 22.9237 87.8611 22.8211C87.8821 22.7185 87.816 22.6182 87.7134 22.5972L86.7825 22.406Z"
          fill="#F3A802"
        />
        <path
          d="M89.0411 23.1742C89.0622 23.0716 89.1625 23.0055 89.2651 23.0266L90.196 23.2181C90.2986 23.2392 90.3646 23.3395 90.3435 23.4421C90.3224 23.5446 90.2222 23.6107 90.1196 23.5896L89.1886 23.3981C89.0861 23.377 89.02 23.2768 89.0411 23.1742Z"
          fill="#F3A802"
        />
        <path
          d="M88.4221 23.8117C88.4432 23.7091 88.3771 23.6088 88.2745 23.5878C88.1719 23.5667 88.0716 23.6328 88.0506 23.7354L87.8594 24.6664C87.8384 24.769 87.9045 24.8692 88.007 24.8903C88.1096 24.9113 88.2099 24.8452 88.2309 24.7426L88.4221 23.8117Z"
          fill="#F3A802"
        />
        <path
          d="M113.695 13.3645C113.716 13.2619 113.65 13.1616 113.547 13.1406C113.445 13.1195 113.345 13.1856 113.324 13.2882L113.132 14.2191C113.111 14.3217 113.177 14.422 113.28 14.443C113.383 14.4641 113.483 14.398 113.504 14.2954L113.695 13.3645Z"
          fill="#09798D"
        />
        <path
          d="M111.435 14.4413C111.332 14.4202 111.232 14.4863 111.211 14.5889C111.19 14.6915 111.256 14.7918 111.359 14.8128L112.289 15.004C112.392 15.025 112.492 14.959 112.513 14.8564C112.534 14.7538 112.468 14.6535 112.366 14.6325L111.435 14.4413Z"
          fill="#09798D"
        />
        <path
          d="M113.693 15.2095C113.715 15.1069 113.815 15.0408 113.917 15.0619L114.848 15.2534C114.951 15.2745 115.017 15.3748 114.996 15.4773C114.975 15.5799 114.875 15.646 114.772 15.6249L113.841 15.4334C113.738 15.4123 113.672 15.3121 113.693 15.2095Z"
          fill="#09798D"
        />
        <path
          d="M113.074 15.847C113.096 15.7444 113.029 15.6441 112.927 15.6231C112.824 15.602 112.724 15.6681 112.703 15.7707L112.512 16.7016C112.491 16.8042 112.557 16.9045 112.659 16.9255C112.762 16.9466 112.862 16.8805 112.883 16.7779L113.074 15.847Z"
          fill="#09798D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.3588 15.3796L21.4913 15.614L21.8595 14.7465L21.4003 13.9502L22.2852 14.0336L22.8689 13.3071L23.0476 14.2262L23.8676 14.5734L23.0931 15.058L23.0162 15.9991L22.3588 15.3796Z"
          stroke="#F3A802"
          strokeWidth="0.379272"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M62.2833 49.1907C65.7928 49.1907 68.6378 46.3457 68.6378 42.8362C68.6378 39.3267 65.7928 36.4816 62.2833 36.4816C58.7737 36.4816 55.9287 39.3267 55.9287 42.8362C55.9287 46.3457 58.7737 49.1907 62.2833 49.1907Z"
          stroke="#493D7E"
          strokeMiterlimit="10"
        />
        <rect
          x="46.5"
          y="31.249"
          width="30.7728"
          height="22.8296"
          rx="3.5"
          stroke="#493D7E"
        />
        <path
          d="M60 31V31C60 29.3431 58.6569 28 57 28H54C52.3431 28 51 29.3431 51 31V31"
          stroke="#493D7E"
        />
        <path
          d="M76.0406 60C79.2867 60 81.9182 57.3685 81.9182 54.1224C81.9182 50.8763 79.2867 48.2449 76.0406 48.2449C72.7946 48.2449 70.1631 50.8763 70.1631 54.1224C70.1631 57.3685 72.7946 60 76.0406 60Z"
          fill="#F5F5F5"
          stroke="#493D7E"
          strokeMiterlimit="10"
        />
        <path
          d="M76.8605 50.9779C76.8605 50.6489 76.6318 50.3822 76.3498 50.3822C76.0678 50.3822 75.8392 50.6489 75.8392 50.9779V53.446H73.3711C73.0421 53.446 72.7754 53.6746 72.7754 53.9566C72.7754 54.2387 73.0421 54.4673 73.3711 54.4673H75.8392V56.9353C75.8392 57.2644 76.0678 57.5311 76.3498 57.5311C76.6318 57.5311 76.8605 57.2644 76.8605 56.9353V54.4673H79.3285C79.6575 54.4673 79.9243 54.2387 79.9243 53.9566C79.9243 53.6746 79.6575 53.446 79.3285 53.446H76.8605V50.9779Z"
          fill="#493D7E"
        />
        <rect
          x="3.2163"
          y="1.2163"
          width="121.567"
          height="85.5674"
          rx="6.7837"
          stroke="white"
          strokeWidth="2.4326"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_574_3331"
          x="0"
          y="0"
          width="128"
          height="94"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_574_3331"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0 0.294118 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_574_3331"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_574_3331"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0 0.294118 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_574_3331"
            result="effect2_dropShadow_574_3331"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_574_3331"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default AddPhoto;
